'use client';

import type { OcapiProps } from '../types';
import { useUserSession } from './useUserSession';

type UseBasketCount = {
    isLoading: boolean;
    basketCount: number;
    handleBasketCount: (cartCount: number) => void;
};

export const useBasketCount = (): UseBasketCount => {
    const { storageUserSession, ocapi, setOcapi } = useUserSession();

    let basketCount = 0;

    if (!ocapi.isLoading) {
        basketCount = ocapi.data?.basket
            ? ocapi.data?.basket.product_quantity_total
            : (storageUserSession?.basketCount ?? 0);
    }

    const handleBasketCount = (cartCount: number) => {
        const ocapiData = ocapi.data
            ? {
                  ...ocapi.data,
                  basket: {
                      ...ocapi.data.basket,
                      product_quantity_total: cartCount,
                  },
              }
            : {};

        setOcapi({
            ...ocapi,
            data: ocapiData as OcapiProps,
        });
    };

    return { isLoading: ocapi.isLoading, basketCount, handleBasketCount };
};
